import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { LoomIcon } from '@atlaskit/temp-nav-app-icons/loom';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function loom(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <LoomIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		apsKey: Products.LOOM,
		fallbackUrl,
	};
}
